import type { MessageDescriptor } from 'react-intl';

import type { FormatMessage } from '@tmapy/intl';

import type { FlowEnum } from '../../openapi/types/FlowEnum';
import type { NestedSubjektResponse } from '../../openapi/types/NestedSubjekt';
import { docRejectedByMessages, docStateMessages } from '../components/docsMessages';
import { DOC_STATE } from '../constants';

type FormatDescriptor = (
  descriptor: MessageDescriptor,
  values?: Parameters<FormatMessage>[1],
) => string;

const joinSubjektNames = (subjekty: readonly NestedSubjektResponse[] = []) =>
  subjekty
    .map((subjekt) => `${subjekt?.jmeno ?? ''}`.trim())
    .filter(Boolean)
    .join(', ');

export const formatDocState = (
  formatMessage: FormatDescriptor,
  state: DOC_STATE,
  flow?: FlowEnum | '' | null,
  rejectedBySubjekty?: readonly NestedSubjektResponse[],
): string | null => {
  const rejectingNames =
    state === DOC_STATE.REJECTED_BY_COUNTERPART ? joinSubjektNames(rejectedBySubjekty) : '';
  if (rejectingNames) {
    return formatMessage(docRejectedByMessages.rejectedBySubjekty, { names: rejectingNames });
  }

  const stateMessage = docStateMessages[state];
  return stateMessage ? formatMessage(stateMessage, { id: flow }) : null;
};
